import type { Component } from "svelte";
import { CartModalKind } from "@core/schema/CartModalKind.js";
import ClearForCourseOrder from "./ClearForCourseOrder.svelte";
import ClearForPreorder from "./ClearForPreorder.svelte";
import ClearForProducts from "./ClearForProducts.svelte";
import ClearForSubscription from "./ClearForSubscription.svelte";
import FfcMembersOnly from "./FfcMembersOnly.svelte";
import OrderAlreadyExists from "./OrderAlreadyExists.svelte";
import OrderError from "./OrderError.svelte";
import VouchersRemoved from "./VouchersRemoved.svelte";

export const cartModalComponentMap = {
	[CartModalKind.OrderError]: OrderError,
	[CartModalKind.OrderAlreadyExists]: OrderAlreadyExists,
	[CartModalKind.ClearForSubscription]: ClearForSubscription,
	[CartModalKind.ClearForProducts]: ClearForProducts,
	[CartModalKind.ClearForCourseOrder]: ClearForCourseOrder,
	[CartModalKind.ClearForPreorder]: ClearForPreorder,
	[CartModalKind.FfcMembersOnly]: FfcMembersOnly,
	[CartModalKind.VouchersRemoved]: VouchersRemoved,
} satisfies Record<CartModalKind, Component<never>>;
